import { useMemo } from 'react';
import type { Edge } from 'reactflow';

// Pure derivation: each edge's target → source. Sole source for the
// lift-in arrival animation (Task 9 useTweenedNodePositions) and any
// future ancestor-aware layout code. No side-output path through
// layoutChatDag (architect A3 — chatDagLayout stays a pure
// geometry function).

export function deriveAncestorMap(edges: Edge[]): Map<string, string> {
  const map = new Map<string, string>();
  for (const e of edges) map.set(e.target, e.source);
  return map;
}

export function useAncestorMap(edges: Edge[]): Map<string, string> {
  return useMemo(() => deriveAncestorMap(edges), [edges]);
}
